export default {
  // 2-14
  cst_choicelist: [],
  cst_applier: [],
  cst_applierlist: [],

  // 2-15
  cst_forcensor: [],
  cst_forcensorlist: [],
};
